import chroma from 'chroma-js';
import { useMiscData } from './useMiscData';

export const useTheme = () => {
    const fallbackColor = '#FFD6A7';
    const disabled = false;
    let { mainColor } = useMiscData();
    if (!disabled) {
        mainColor = fallbackColor;
        return {
            primaryColor: mainColor,
            secondaryColor: chroma(mainColor).brighten(0.5).hex(),
            requiresWhiteText: chroma.contrast('white', mainColor) > 4,
        };
    } else {
        return {};
    }
};
